import { render, staticRenderFns } from "./processAccidentRisk.vue?vue&type=template&id=6ddfc981"
import script from "./processAccidentRisk.vue?vue&type=script&lang=js"
export * from "./processAccidentRisk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ddfc981')) {
      api.createRecord('6ddfc981', component.options)
    } else {
      api.reload('6ddfc981', component.options)
    }
    module.hot.accept("./processAccidentRisk.vue?vue&type=template&id=6ddfc981", function () {
      api.rerender('6ddfc981', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/iim/reg/processAccidentRisk.vue"
export default component.exports